/// <reference path="../_references.ts"/>

module App.Dashboard {
	import UserSession = App.User.UserSession;
	import User = App.User.User;

	interface LocalScope extends ng.IScope {
		menu: App.User.UserMenuController;
	}

	export class DashboardController {
		static $inject = ['DashboardService', 'UserSession', '$scope'];

		stats: TechStats;
		user: User;
		selectedDateRange: Range;

		conversionRate: string;
		avgSoldMinutes: string;
		loading = true;

		init: boolean = false;

		constructor(
			private DashboardService: DashboardService,
			private UserSession: UserSession,
			protected $scope: LocalScope
		) {
			if ($scope.menu.showDashboard) {
				this.doInit();
			} else {
				const watch = $scope.$watch(
					() => $scope.menu.showDashboard,
					v => {
						if (v) {
							watch();
							this.doInit();
						}
					}
				);
			}
		}

		doInit(): void {
			if (this.init) {
				return;
			}

			this.init = true;

			this.selectedDateRange = this.dateRanges[3];

			this.UserSession.getUser().then((user) => {
				this.user = user;
				this.updateDateRange();
			});
		}

		updateDateRange() {
			this.loading = true;
			this.DashboardService.getStats(this.user.technician.id, this.selectedDateRange.start, this.selectedDateRange.end).then((response) => {
				this.stats = response.data;

				if (this.stats.serviceRequestCount != 0) {
					this.conversionRate = (this.stats.hasSoldMinutesCount / this.stats.serviceRequestCount * 100).toFixed(1);
					this.avgSoldMinutes = (this.stats.totalSoldMinutes / this.stats.serviceRequestCount).toFixed(1);
				} else {
					this.conversionRate = '0';
					this.avgSoldMinutes = '0';
				}

				this.loading = false;
			});
		}

		today: Date = moment().add(1, 'day').toDate();
		dateRanges: Range[] = [
			{
				name: 'Today',
				start: moment().toDate(),
				end: this.today
			},
			{
				name: 'Yesterday',
				start: moment().subtract(1, 'day').toDate(),
				end: moment().toDate()
			},
			{
				name: 'Beginning Monday',
				start: moment().startOf('isoWeek').toDate(),
				end: this.today
			},
			{
				name: 'This Month',
				start: moment().startOf('month').toDate(),
				end: this.today
			},
			{
				name: 'Last Month',
				start: moment().subtract(1, 'month').startOf('month').toDate(),
				end: moment().subtract(1, 'month').endOf('month').toDate()
			}
		];
	}
}